/**
 * SectionHead — editorial-заголовок секции в стиле «Қара алтын»:
 *   01 / ПРИЛОЖЕНИЯ ————————————
 *   Жирный гротеск + курсивная антиква
 */
import type { ReactNode } from "react";

interface SectionHeadProps {
  /** «02» */
  num: string;
  /** «ПРИЛОЖЕНИЯ» */
  label: string;
  /** Жирная часть заголовка */
  title: string;
  /** Курсивная serif-часть заголовка */
  accent: string;
  /** Подпись справа от заголовка (опционально) */
  aside?: ReactNode;
}

export function SectionHead({ num, label, title, accent, aside }: SectionHeadProps) {
  return (
    <div className="mb-8 sm:mb-16">
      <div className="section-rule mb-6 sm:mb-8" data-reveal="" >
        <span className="t-eyebrow reveal" data-reveal="">
          <b>{num}</b>&nbsp;/&nbsp;{label}
        </span>
      </div>
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <h2
          className="t-display reveal"
          data-reveal=""
          style={{ fontSize: "var(--text-display)" }}
        >
          {title}{" "}
          <em
            className="t-serif-i"
            style={{ color: "var(--fg-soft)", fontWeight: 500 }}
          >
            {accent}
          </em>
        </h2>
        {aside ? (
          <div
            className="reveal max-w-md text-base leading-relaxed"
            data-reveal=""
            style={{ color: "var(--fg-soft)", "--reveal-delay": "120ms" } as React.CSSProperties}
          >
            {aside}
          </div>
        ) : null}
      </div>
    </div>
  );
}
